import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service.jsx";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import NightingleChart from "../OfftakeCharts/NightingleChart.js";

const top_regulatory = async (body) => {
  try {
    const res = await axInst.post("offtake/dealer-wise-offtake", body);
    const result = res.data["dealer-wise-offtake"];

    const parsedData = result.map((item) => ({
      name: item.key,
      value: item.total_offtake.value,
    }));

    return parsedData;
  } catch (error) {
    console.error(error);
  }
};

const TopRegulatory = () => {
  const { data, submitted } = useSelector((e) => e.filtersOfftake);

  const {
    data: resolution,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["regulatory", submitted],
    queryFn: () => top_regulatory(data),
    enabled: !!data,
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  return (
    <div className="relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      {!isFetching && !resolution && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Data not available</p>
        </div>
      )}
      <WaterMark />
      <div>{resolution && <NightingleChart data={resolution} />}</div>
    </div>
  );
};
export default TopRegulatory;
